import { Document } from "mongoose";

export enum CUSTOMER_TYPE {
  prospect = "PROSPECT",
  lead = "LEAD",
  customer = "CUSTOMER",
}

export enum CUSTOMER_LANGUAGE {
  EN = "EN",
  IT = "IT",
  DE = "DE",
  ES = "ES",
  FR = "FR",
  RU = "RU",
}

export enum COMPANY_STATUS {
  PROGRESS = "progress",
  PENDING = "pending",
  CLOSED = "closed"
}

export interface OffCustomerAddress {
  street: string,
  zip: string,
  city: string,
  province: string,
  country: string
}

export interface OffCustomerContact {
  id: number;
  gender: string;
  name: string;
  surname: string;
  email: string;
  phone: string;
  language: CUSTOMER_LANGUAGE;
  department: string;
}

export interface OffCustomerObject {
  crmId: number;
  id: number;
  name: string;
  type: CUSTOMER_TYPE;
  address: OffCustomerAddress;
  commodity: string;
  fiscalCode: string;
  VAT: string;
  contact: OffCustomerContact;
}

export enum LANES_TRAILER_TYPE {

}

export enum LANES_CURRENCY {
  EUR = 'EUR',
  PLN = 'PLN',
  RON = 'RON'
}

export enum LANES_RESULT {
  ACCEPTED = 'Accepted',
  DECLINED = 'Declined',
}

export interface OffLanesCollection {
  zone: string;
  country: string;
  zip: string;
  city: string;
}

export interface OffLanesDeleveries {
  zone: string;
  country: string;
  zip: string;
  city: string;
}

export interface OffLanesObject {
  trailerType: LANES_TRAILER_TYPE;
  trips: number;
  dateFrom: Date;
  dateTo: Date;
  notes: string;
  collections: OffLanesCollection[];
  deliveries: OffLanesDeleveries[];
  currency: LANES_CURRENCY;
  price: number;
  feedback: number;
  result: LANES_RESULT;
}

export interface OffSpecifications {
  id: string;
  notes: string;
}

export interface OffChangeLog { }

export interface OffOffer extends Document {
  _id: any;
  company: number;
  number: number;
  branch: string;
  year: number;
  status: COMPANY_STATUS;
  date: Date;
  validityDate: Date;
  owner: OffOwner;
  customer: OffCustomerObject;
  lanes: OffLanesObject[];
  specifications: OffSpecifications[];
  gtec: string;
  notes: string;
  changelog?: OffChangeLog;
  insert_date: Date;
  update_date: Date;
  insert_user?: string;
  update_user?: string;
}
export interface OffOwner {
  name?: string;
  email?: string;
  phone?: string;
}

